import { Box, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const X_COLORS = {
  background: "#000000",
  text: "#E7E9EA",
  link: "#1D9BF0",
  muted: "#333639",
  card: "#16181C",
} as const;

export const Root = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  backgroundColor: X_COLORS.background,
  color: X_COLORS.text,
}));

export const TopBar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const Drafts = styled(Typography)({
  color: X_COLORS.link,
  fontWeight: 700,
  fontSize: 15,
});

export const Body = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
}));

export const Avatar = styled(Box)({
  width: 40,
  height: 40,
  borderRadius: "50%",
  backgroundColor: X_COLORS.muted,
  flexShrink: 0,
});

export const Content = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(1.5),
  flex: 1,
  minWidth: 0,
}));

export const Text = styled(Typography)({
  fontSize: 15,
  lineHeight: 1.35,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
});

export const Link = styled(Typography)({
  fontSize: 15,
  lineHeight: 1.35,
  color: X_COLORS.link,
  overflowWrap: "anywhere",
});

export const CardFrame = styled(Box)({
  position: "relative",
  width: "100%",
  aspectRatio: "16 / 9",
  borderRadius: 12,
  border: `1px solid ${X_COLORS.muted}`,
  overflow: "hidden",
  backgroundColor: X_COLORS.card,
});

export const CardSkeleton = styled(Skeleton)({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  backgroundColor: X_COLORS.muted,
});

export const Card = styled("img", {
  shouldForwardProp: (prop) => prop !== "$visible",
})<{ $visible: boolean }>(({ $visible }) => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: $visible ? "block" : "none",
}));
